import Homepage from "./components/Homepage";
import "./assets/css/index.css"
import DrawProvider from "./redux/core/DrawProvider";
import {QueryClient, QueryClientProvider} from "react-query";


const queryClient = new QueryClient();

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <DrawProvider>
                <Homepage/>
            </DrawProvider>
        </QueryClientProvider>
    );
}

export default App;
